import { Routes } from '@angular/router';
import { AuthGuardWithForcedLogin } from '@ortho-next/auth-core';
import { ErrorComponent, FallbackComponent } from './core';
import { LegalTermsComponent } from './legal-terms';
import { LegalTermsAcceptanceComponent } from './legal-terms-acceptance';
import { LegalTermsPageComponent } from './legal-terms-page';
import { SuccessPageComponent } from './success-page';
import { UserRequestComponent } from './user-request';


export enum PAGE {
	ERROR = 'error',
	REQUEST = 'userRequest',
	REQUEST_LEGAL_TERMS = 'legalTerms',
	REQUEST_SUCCESS = 'success',
	LEGAL_TERMS = 'legal-terms',
	LEGAL_TERMS_ACCEPTANCE = 'legal-terms-acceptance'
}

export const routes: Routes = [
	{ path: '', redirectTo: PAGE.REQUEST, pathMatch: 'full' },
	{ path: PAGE.REQUEST, component: UserRequestComponent },
	{ path: PAGE.REQUEST_LEGAL_TERMS, component: LegalTermsComponent },
	{ path: PAGE.REQUEST_SUCCESS, component: SuccessPageComponent },
	{ path: PAGE.LEGAL_TERMS, component: LegalTermsPageComponent },
	{ path: PAGE.LEGAL_TERMS_ACCEPTANCE, component: LegalTermsAcceptanceComponent, canActivate: [AuthGuardWithForcedLogin] },
	{ path: PAGE.ERROR, component: ErrorComponent },
	{ path: '**', component: FallbackComponent }
];